import React, { useRef, useState } from 'react';
import EyeVisible from '../../Icons/EyeVisible';
import './Input.scss';

const Input = ({ type, name, label, onChange, error, eyeIcon, ...rest }) => {
  const className = 'c-Input';
  const baseClassNames = [className, error ? ` ${className}--error` : ''].join(
    ''
  );

  const inputRef = useRef(null);
  const [isEyeIconVisible, setIsEyeIconVisible] = useState(false);

  function toggleInputVisibility() {
    const inputType = inputRef?.current?.type;
    if (inputType === 'password') inputRef.current.type = 'text';
    else inputRef.current.type = 'password';

    setIsEyeIconVisible((prevBool) => !prevBool);
  }

  function renderEyeIcon() {
    return (
      eyeIcon && (
        <div
          className={`${className}__container__icon`}
          onClick={toggleInputVisibility}
        >
          <EyeVisible isOpen={isEyeIconVisible} />
        </div>
      )
    );
  }

  return (
    <div className={baseClassNames}>
      {label && <label htmlFor={name}>{label}</label>}
      <div className={`${className}__container`}>
        <input
          ref={inputRef}
          name={name}
          type={type}
          onChange={onChange}
          {...rest}
        />
        {renderEyeIcon()}
      </div>
      {error && <p className={`${className}__error`}>{error}</p>}
    </div>
  );
};

Input.defaultProps = {
  type: 'text',
  name: '',
  label: '',
  error: '',
  eyeIcon: false,
};

export default Input;
